import React from 'react'

function TradingResources() {
  return (
    <div className="bg-background-secondary-color rounded-lg p-6 font-popins mt-5 lg:m-[100px]">
      <h2 className="text-3xl font-extrabold text-red-400 mb-10">Trading Resources</h2>
      <div className="space-y-8 max-w-4xl">
        <div className="flex items-start">

        </div>

      </div>
    </div>
  )
}

export default TradingResources;
